require("../app/page_switch.coffee");
require("../app/bulletin_filter.coffee")

window.pageInitFlag = false

pageInit = ->
  new window.PageSwitch()
  new window.BulletinFilter()


$(document).ready ->
  if window.pageInitFlag != true
    pageInit()
  window.pageInitFlag = true

$(document).on 'page:load', ->
  new window.PageSwitch()


// WEBPACK FOOTER //
// ./assets/javascripts/pages/collegium.coffee